// extracted by mini-css-extract-plugin
export default {"root":"styles_root__YtX0u","tag":"styles_tag__7AJWT","tag-overflow":"styles_tag-overflow__VtnLl"};